import { SkillTag } from 'components/common/Tag/SkillTag';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { axiosInstance } from 'services/axios';
import { JobType } from 'types';

import { DLink, SvgUse } from '@dnse/ui';


interface Props {
  totalNumberOpeningJobs: number;
  recommendSkills: string[];
}

const DEBOUNCE_TIME = 500;
export const JobsOpportunitiesBanner: React.FC<Props> = ({
  totalNumberOpeningJobs,
  recommendSkills
}) => {
  const router = useRouter();
  const [searchInput, setSearchInput] = useState<string>('');
  const [results, setResults] = useState<JobType[]>([]);
  const [isShowResult, setIsShowResult] = useState<boolean>(false);

  let debounceTimeout: NodeJS.Timeout;

  useEffect(() => {
    setSearchInput(router.query.keyword as string);
  }, [router.query]);

  const FetchJobsByTitle = async (input: string) => {
    if (input.length > 0) {
      const apiUrl = 'api/jobs';
      const payload = {
        page: 1,
        limit: 5,
        address: [],
        workType: [],
        department: [],
        skill: [],
        title: input
      };
      await axiosInstance
        .post(apiUrl, payload)
        .then(data => {
          setResults(data.data.jobs);
          setIsShowResult(true);
        })
        .catch(error => {
          setResults([]);
          console.log(error);
        });
    } else {
      setResults([]);
      setIsShowResult(false);
    }
  };

  const handleSearchInputChange = (input: string) => {
    setSearchInput(input);
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      FetchJobsByTitle(input);
    }, DEBOUNCE_TIME);
  };

  const handleClickSearchButton = () => {
    setIsShowResult(false);
    router.replace(
      {
        query: searchInput && { ...router.query, keyword: searchInput },
        pathname: '/co-hoi-viec-lam'
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <div
      className="relative w-full mt-[56px] flex justify-center lg:mb-[24px] py-[32px] flex-col items-center z-10 "
      style={{
        background:
          'linear-gradient(132deg, #FFE7E7 5.6%, #EDEFFF 35.43%, #EEFFFE 66.53%, #FFEEE2 100%)'
      }}
    >
      <div className="text-center">
        <h1
          className="text-2xl lg:text-3xl font-bold text-brand-300"
          data-testid="total-number-opening-jobs"
        >
          {`${totalNumberOpeningJobs} vị trí `}
          <span className="text-black">
            đang tuyển <br className="md:hidden" />
            tại DNSE
          </span>
        </h1>
      </div>
      <div className="my-3 flex items-center gap-x-2 w-full md:w-fit h-[36px] md:h-[50px] px-4">
        <div className="relative w-full md:w-[400px] h-full">
          <div className="absolute ml-3 left-0 top-[8px] md:top-[16px]">
            <SvgUse id={'dnse-logo'} className="w-5 h-5" />
          </div>
          <input
            data-testid="search-input"
            value={searchInput}
            onChange={e => handleSearchInputChange(e.currentTarget.value)}
            placeholder="Nhập từ khoá theo kĩ năng, vị trí..."
            className="w-full text-[14px] h-full text-sm py-1.5 pl-10 pr-2 rounded-full bg-[#F6F6F6] border-transparent border focus:!border-encap focus:outline-none placeholder:text-[#858585]"
          />
          <div className="absolute lg:hidden mr-3 right-0 top-[9px]">
            <SvgUse id="search-big-outline" className="w-5 h-5" />
          </div>
          <div
            className="flex flex-col rounded shadow-md mt-1 z-10"
            style={{
              boxShadow: ' 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
              backdropFilter: 'blur(20px)',
              background: 'var(--light-bg-60, rgba(255, 255, 255, 0.60))'
            }}
          >
            {isShowResult ? (
              results.length > 0 ? (
                results.map(job => (
                  <DLink
                    href={`co-hoi-viec-lam/${job.slug}`}
                    key={job.id}
                    className="p-3 text-sm font-normal cursor-pointer z-10"
                  >
                    {job.title}
                  </DLink>
                ))
              ) : (
                <div className="text-sm font-normal p-3">
                  <span>
                    Không tìm thấy kết quả nào cho{' '}
                    <span className="font-medium">{searchInput}</span>
                    <br />
                  </span>
                  <span className="text-gray-800">
                    Kiểm tra lại từ khóa hoặc thử một cụm từ tìm kiếm khác.
                  </span>
                </div>
              )
            ) : null}
          </div>
        </div>
        <button
          onClick={handleClickSearchButton}
          data-testid="search-button"
          className="h-full hidden md:block whitespace-nowrap px-6 py-2 rounded-[40px] text-base font-medium text-white bg-brand-300 col-span-3"
        >
          Tìm kiếm
        </button>
      </div>
      <div className="px-4 lg:px-0 w-full md:w-fit flex flex-col lg:flex-row lg:items-center justify-start text-gray-700 text-sm font-normal gap-2 flex-wrap mb-2">
        <span className="text-xs">
          Gợi ý cho bạn:
          <br />
        </span>
        <div className="flex items-center gap-2 flex-wrap ">
          {recommendSkills.map((skill, index) => (
            <SkillTag key={index} name={skill} />
          ))}
        </div>
      </div>
    </div>
  );
};
